export default __webpack_public_path__ + "static/media/1.b39209fa.jpg";